import VCanvas from './VCanvas'

export { VCanvas }

export default VCanvas